<template>
  <v-navigation-drawer
    v-model="drawer"
    temporary
    right
    width="500"
    style="height: 100%; top: 64px; padding-bottom: 70px"
    app
    :permanent="permanent"
  >
    <v-card-actions class="mt-4">
      <slot name="button-close"> </slot>
      <v-spacer></v-spacer>
    </v-card-actions>

    <!-- <v-list-item class="mt-4">
      <v-list-item-content>
        <v-list-item-title>
          <slot name="title"> </slot>
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item> -->

    <v-list-item>
      <slot name="content"> </slot>
    </v-list-item>
  </v-navigation-drawer>
</template>
<script>
export default {
  props: {
    active: {
      type: Boolean,
      default: Boolean,
    },
    permanent: {
      type: Boolean,
      default: false,
    },
  },

  created() {},
  computed: {
    drawer: {
      get: function () {
        return this.active;
      },
      set: function (value) {
        !value && this.$emit("close", false);
      },
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.navigation-a-underline--remove {
  text-decoration: none;
}
</style>
